const PUBLIC_STOREFRONT_HOSTS = new Set(["eurolabs-peptides.com", "www.eurolabs-peptides.com"]);

type PostHogEnvironment = {
	nodeEnv?: string;
	disablePostHog?: boolean;
};

export function isPostHogServerCaptureEnabled({
	nodeEnv = process.env.NODE_ENV,
	disablePostHog = process.env.NEXT_PUBLIC_DISABLE_POSTHOG === "1",
}: PostHogEnvironment = {}): boolean {
	return nodeEnv === "production" && !disablePostHog;
}

export function isPostHogBrowserCaptureEnabled({
	nodeEnv = process.env.NODE_ENV,
	disablePostHog = process.env.NEXT_PUBLIC_DISABLE_POSTHOG === "1",
	hostname,
}: PostHogEnvironment & { hostname?: string } = {}): boolean {
	return (
		isPostHogServerCaptureEnabled({ nodeEnv, disablePostHog }) &&
		!!hostname &&
		PUBLIC_STOREFRONT_HOSTS.has(hostname)
	);
}
